import base from '@/http/url_base';

export default {
  CONTACT: base.API + '/tiers-contacts',
  GET_REQUIREMENTS: base.API + '/tiers-contacts/requirements',
  NOTE: base.API + '/tiers-contact-notes',
  CONTACT_PARAM: base.API + '/tiers-contact-params',
  CONTACT_PARAM_REQUIREMENTS: base.API + '/tiers-contact-params/requirements',
};
